module.exports = __webpack_public_path__ + "img/palmar-hotel.aac82c22.jpg";